export default function Logo({ className = "h-10 w-10", dark = false }) {
  if (dark) {
    return (
      <span className={`inline-flex items-center justify-center rounded-full bg-cream p-2 ${className}`}>
        <img src="/logo.png" alt="Vayu Celebrations logo" className="h-full w-auto object-contain" />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center justify-center ${className}`}>
      <img src="/logo.png" alt="Vayu Celebrations logo" className="h-full w-auto object-contain" />
    </span>
  );
}
